module.exports = __webpack_public_path__ + "img/compass_plate.e856d992.png";